import { CreditCard } from 'lucide-react';

const Tender = ({ tender }) => {
  const formattedAmount = (tender.amount / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  });

  return (
    <div className="flex items-center gap-4">
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <CreditCard className="h-6 w-6 text-muted-foreground" />
          <span
            className="text-sm font-medium"
            aria-label={`${tender.cardBrand} card ending in ${tender.last4}`}
          >
            <span aria-hidden="true">•••• •••• •••• </span>
            {tender.last4}
          </span>
        </div>
        <span className="text-sm text-muted-foreground">
          {tender.cardBrand.toUpperCase()}
        </span>
      </div>
      <div className="text-sm text-muted-foreground ml-auto">
        {formattedAmount}
      </div>
    </div>
  );
};

export default Tender;
